const viewMoreButton = () => {
  const viewMore = document.querySelector('[data-blogs-view-more]')
  const pagination = document.querySelector('[data-pagination]')
  if (viewMore) {
    pagination.classList.add('hide')
    viewMore.addEventListener('click', (e) => {
      e.preventDefault();
      const blogsHiddenShows = document.querySelectorAll('[data-blogs-show].hide');
      if (blogsHiddenShows.length > 0) {
        [...blogsHiddenShows].slice(0,9).forEach(blogsShowBtn => {
          blogsShowBtn.classList.remove('hide')
        })
      }        
      if (blogsHiddenShows.length >= 9) {
        viewMore.classList.add('hide')
        pagination.classList.remove('hide')
      }
    })
  }
}

export default viewMoreButton()